import { createTheme } from '@mui/material/styles'

export const tokens = {
  colors: {
    primary: '#279596',
    primaryLight: '#BEDFDF',
    primaryExtraLight: '#DFEFEF',
    error: '#E84C3D',
    errorLight: 'rgba(232, 76, 61, 0.15)',
    white: '#FFFFFF',
    sectionDivider: '#CCCCCC',
    text: { body: '#333333', heading: '#333333', muted: '#8A8A8A', link: '#279596', linkDisabled: 'rgba(39,149,150,0.6)' },
    secondaryButton: { border: '#333333', background: '#FFFFFF', hover: '#EEEEEE', disabled: '#F7F7F7', text: '#333333' },
    inputField: { background: '#EEEEEE', border: '#3A3A3A', focusedBorder: '#279596', text: '#333333', placeholder: '#A6A6A6' },
    background: { white: '#FFFFFF', light: '#F7F7F7', medium: '#EEEEEE', pageOverlay: 'rgba(85,85,85,0.7)' },
    status: {
      raw: '#8FA3BB',
      loading: '#FFAC47',
      ready: '#10D070',
      done: '#10C0D0',
      applied: '#55ACAC', // redactions burned in: the primary teal softened
      warning: '#D0C610',
      loadingText: '#B06A00' // the loading orange darkened for text on its tint
    }
  },
  borderRadius: { button: '20px', iconButton: '5px', div: '20px', input: '5px' },
  spacing: { icon: '5px', compact: '10px', control: '20px', section: '30px' },
  fonts: { heading: 'Montserrat, sans-serif', body: 'Montserrat, sans-serif' }
}

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: tokens.colors.primary, light: tokens.colors.primaryLight },
    error: { main: tokens.colors.error },
    text: { primary: tokens.colors.text.body },
    background: { default: tokens.colors.white }
  },
  typography: { fontFamily: tokens.fonts.body },
  shape: { borderRadius: 5 }
})
